<template>
    <b-form-row class="mb-2 d-inline">
      <b-col class="mb-1 mb-lg-0">
        <h6><b-skeleton width="10%"></b-skeleton></h6>
        <b-form-row>
          <b-col
            v-for="index in 5" :key="index"
            class="mb-1"
          >
            <b-card
              class="h-100 mb-0"
            >
              <b-skeleton width="30%" class="mb-75"></b-skeleton>
              <b-skeleton width="60%" class="mb-75"></b-skeleton>
              <b-skeleton width="40%" class="mb-75"></b-skeleton>
              <b-skeleton width="70%" class="mb-75"></b-skeleton>
            </b-card>
          </b-col>
          </b-form-row>
      </b-col>
      <b-col class="mb-1 mb-lg-0">
        <b-row
          class="d-flex justify-content-between mb-1"
        >
          <b-col sm="4">
            <h6 class="mb-0 my-50">
              <b-skeleton width="30%" class="mb-0"></b-skeleton>
            </h6>
          </b-col>
          <b-col
           sm="8"
           class="d-flex justify-content-end"
          >
            <b-skeleton type="button"></b-skeleton>
          </b-col>
        </b-row>
        <b-form-row>
          <b-col v-for="index in 6" :key="index"
                  cols="12"
                  sm="4"
                  md="3"
                  lg="2"
                  class="mb-1">
            <b-card
              class="h-100 mb-0"
            >
              <b-skeleton width="70%" class="mb-75"></b-skeleton>
              <b-skeleton width="40%" class="mb-75"></b-skeleton>
              <b-skeleton width="70%" class="mb-75"></b-skeleton>
            </b-card>
          </b-col>
          </b-form-row>
      </b-col>
      <b-col>
        <b-card>
          <b-skeleton-img no-aspect height="280px"></b-skeleton-img>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <h6><b-skeleton width="10%"></b-skeleton></h6>
          <b-skeleton-table
            :rows="4"
            :columns="11"
          ></b-skeleton-table>
        </b-card>
      </b-col>
    </b-form-row>
</template>

<script>
export default {
  props: {
    records: {
      type: Number,
      default: 9,
    },
  },
}
</script>
